module.exports = __webpack_public_path__ + "static/media/image3.fe8990c3.png";